import mediaLazyLoad from './rbata.mediaLazyLoad';

import {Cloudinary, Util, HtmlTag} from 'cloudinary-core';

const startCloudinaryResponsive = () => {

    const cl = Cloudinary.new({cloud_name: "alphatauri"});

    cl.config({
        breakpoints:                ACC.cloudinaryBreakpoints,
        responsive_use_breakpoints: true
    });

    // Cloudinary methods that were not exposed
    function normalizeToArray_toConsumableArray(arr) {
        return normalizeToArray_arrayWithoutHoles(arr) ||
                normalizeToArray_iterableToArray(arr) ||
                normalizeToArray_unsupportedIterableToArray(arr) ||
                normalizeToArray_nonIterableSpread();
    }

    function normalizeToArray_nonIterableSpread() {
        throw new TypeError(
                "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    function normalizeToArray_unsupportedIterableToArray(o, minLen) {
        if (!o) {
            return;
        }
        if (typeof o === "string") {
            return normalizeToArray_arrayLikeToArray(o, minLen);
        }
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) {
            n = o.constructor.name;
        }
        if (n === "Map" || n === "Set") {
            return Array.from(o);
        }
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
            return normalizeToArray_arrayLikeToArray(o, minLen);
        }
    }

    function normalizeToArray_iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) {
            return Array.from(iter);
        }
    }

    function normalizeToArray_arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) {
            return normalizeToArray_arrayLikeToArray(arr);
        }
    }

    function normalizeToArray_arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) {
            len = arr.length;
        }
        for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; }
        return arr2;
    }

    function normalizeToArray(elements) {
        if (Util.isArray(elements)) {
            return elements;
        } else if (elements.constructor.name === "NodeList") {
            return normalizeToArray_toConsumableArray(elements); // ensure an array is always returned, even if nodelist
        } else if (Util.isString(elements)) {
            return Array.prototype.slice.call(document.querySelectorAll(elements), 0);
        } else {
            return [elements];
        }
    }

    function applyBreakpoints(tag, width, steps, options) {
        var ref, ref1, ref2, responsive_use_breakpoints;
        responsive_use_breakpoints = (ref =
                (ref1 = (ref2 = options['responsive_use_breakpoints']) != null ? ref2 : options['responsive_use_stoppoints']) != null ? ref1
                        : cl.config('responsive_use_breakpoints')) != null ? ref : cl.config('responsive_use_stoppoints');
        if ((!responsive_use_breakpoints) || (responsive_use_breakpoints === 'resize' && !options.resizing)) {
            return width;
        } else {
            return cl.calc_breakpoint(tag, width, steps);
        }
    }

    function findContainerWidth(element) {
        var containerWidth, style;
        containerWidth = 0;
        while (((element = element != null ? element.parentNode : void 0) instanceof Element) && !containerWidth) {
            style = window.getComputedStyle(element);
            if (!/^inline/.test(style.display)) {
                containerWidth = Util.width(element);
            }
        }
        return containerWidth;
    }

    function maxWidth(requiredWidth, tag) {
        var imageWidth;
        imageWidth = Util.getData(tag, 'width') || 0;
        if (requiredWidth > imageWidth) {
            imageWidth = requiredWidth;
            Util.setData(tag, 'width', requiredWidth);
        }
        return imageWidth;
    }

    function updateDpr(dataSrc, roundDpr) {
        return dataSrc.replace(/\bdpr_(1\.0|auto)\b/g, 'dpr_' + cl.device_pixel_ratio(roundDpr));
    }

    // Cloudinary integration - source method prototype override - we need to control final src change
    cl.cloudinary_update = function (elements, options) {
        var containerWidth, dataSrc, match, ref4, requiredWidth;
        if (elements === null) {
            return this;
        }
        if (options == null) {
            options = {};
        }
        const responsive = options.responsive != null ? options.responsive : this.config('responsive');

        elements = normalizeToArray(elements);

        let responsiveClass;
        if (this.responsiveConfig && this.responsiveConfig.responsive_class != null) {
            responsiveClass = this.responsiveConfig.responsive_class;
        } else if (options.responsive_class != null) {
            responsiveClass = options.responsive_class;
        } else {
            responsiveClass = this.config('responsive_class');
        }

        let roundDpr = options.round_dpr != null ? options.round_dpr : this.config('round_dpr');
        elements.forEach(tag => {
            if (/img/i.test(tag.tagName)) {
                let setUrl = true;
                if (responsive) {
                    addClass(tag, responsiveClass);
                }
                dataSrc = Util.getData(tag, 'src-cache') || Util.getData(tag, 'src');
                if (!Util.isEmpty(dataSrc)) {
                    // Update dpr according to the device's devicePixelRatio
                    dataSrc = updateDpr.call(this, dataSrc, roundDpr);
                    if (HtmlTag.isResponsive(tag, responsiveClass)) {
                        containerWidth = findContainerWidth(tag);
                        if (containerWidth !== 0) {
                            if (/w_auto:breakpoints/.test(dataSrc)) {
                                requiredWidth = maxWidth(containerWidth, tag);
                                if (requiredWidth) {
                                    dataSrc = dataSrc.replace(/w_auto:breakpoints([_0-9]*)(:[0-9]+)?/, `w_auto:breakpoints$1:${requiredWidth}`);
                                } else {
                                    setUrl = false;
                                }
                            } else {
                                match = /w_auto(:(\d+))?/.exec(dataSrc);
                                if (match) {
                                    requiredWidth = applyBreakpoints.call(this, tag, containerWidth, match[2], options);
                                    requiredWidth = maxWidth(requiredWidth, tag)
                                    if (requiredWidth) {
                                        dataSrc = dataSrc.replace(/w_auto[^,\/]*/g, `w_${requiredWidth}`);
                                    } else {
                                        setUrl = false;
                                    }
                                }
                            }
                            Util.removeAttribute(tag, 'width');
                            if (!options.responsive_preserve_height) {
                                Util.removeAttribute(tag, 'height');
                            }
                        } else {
                            // Container doesn't know the size yet - usually because the image is hidden or outside the DOM.
                            setUrl = false;
                        }
                    }

                    const isLazyLoading = (options.loading === 'lazy' && !this.isNativeLazyLoadSupported() && this.isLazyLoadSupported()
                            && !elements[0].getAttribute('src'));
                    if (setUrl || isLazyLoading) {
                        // If data-width exists, set width to be data-width
                        this.setAttributeIfExists(elements[0], 'width', 'data-width');
                    }

                    if (setUrl && !isLazyLoading) {
                        Util.setAttribute(tag, 'data-cld-src', dataSrc);
                    }
                }
            }
        });

        // Call will be done once cloudinary update all sources
        mediaLazyLoad.cloudinaryLazyLoadInit(elements);
        return this;
    }

    cl.responsive();
}

export default startCloudinaryResponsive;